/* (c) Copyright Frontify Ltd., all rights reserved. */

export const MENTION_PLUGIN = 'mention-plugin';
